// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Crimson_Text_fbb0e2', '__Crimson_Text_Fallback_fbb0e2'"},"className":"__className_fbb0e2"};